import { render } from "./EventList.vue?vue&type=template&id=334c2440&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=334c2440&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-334c2440"

export default script